"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _MoreVert = _interopRequireDefault(require("@material-ui/icons/MoreVert"));

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));

var _Popper = _interopRequireDefault(require("@material-ui/core/Popper"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _ClickAwayListener = _interopRequireDefault(require("@material-ui/core/ClickAwayListener"));

var DropdownItem = function DropdownItem(_ref) {
  var icon = _ref.icon,
      label = _ref.label,
      onClick = _ref.onClick;
  return /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    onClick: onClick,
    className: "flex items-center w-40 px-4 py-2 text-sm text-gray-light hover:bg-secondary"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "mr-2"
  }, icon, " "), /*#__PURE__*/_react["default"].createElement("div", null, label));
};

var DropdownAction = function DropdownAction(_ref2) {
  var trigger = _ref2.trigger,
      dropdown = _ref2.dropdown;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isOpen = _useState2[0],
      setOpen = _useState2[1];

  var dropdownRef = (0, _react.useRef)(null);
  return /*#__PURE__*/_react["default"].createElement(_ClickAwayListener["default"], {
    onClickAway: function onClickAway() {
      return setOpen(false);
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "inline-block",
    ref: dropdownRef
  }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    className: "cursor-pointer",
    onClick: function onClick() {
      return setOpen(!isOpen);
    }
  }, trigger), /*#__PURE__*/_react["default"].createElement(_Popper["default"], {
    open: isOpen,
    anchorEl: dropdownRef.current,
    style: {
      zIndex: 9999
    }
  }, /*#__PURE__*/_react["default"].createElement(_Paper["default"], {
    className: "py-1"
  }, dropdown))));
};

var ContactHeader = function ContactHeader(_ref3) {
  var avatar = _ref3.avatar,
      actions = _ref3.actions,
      contact = _ref3.contact,
      onClose = _ref3.onClose;
  var name = contact.name,
      jobTitle = contact.jobTitle,
      company = contact.company;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "px-4 pt-2 -mb-4 text-right text-gray-light"
  }, /*#__PURE__*/_react["default"].createElement(DropdownAction, {
    trigger: /*#__PURE__*/_react["default"].createElement(_MoreVert["default"], null),
    dropdown: actions.map(function (_ref4) {
      var icon = _ref4.icon,
          label = _ref4.label,
          onClick = _ref4.onClick;
      return /*#__PURE__*/_react["default"].createElement(DropdownItem, {
        icon: icon,
        label: label,
        onClick: onClick
      });
    })
  }), /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    className: "cursor-pointer",
    onClick: onClose
  }, /*#__PURE__*/_react["default"].createElement(_Close["default"], null))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex bg-card"
  }, avatar, /*#__PURE__*/_react["default"].createElement("div", {
    className: "min-w-0 pr-4"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "font-semibold text-dark text-2xl truncate"
  }, name), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-sm truncate"
  }, jobTitle), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-sm truncate"
  }, company))));
};

var _default = ContactHeader;
exports["default"] = _default;
//# sourceMappingURL=Header.js.map